export var HOUSE_TYPES;
(function (HOUSE_TYPES) {
    HOUSE_TYPES["SINGLE_FAMILY_HOUSE"] = "SINGLE_FAMILY_HOUSE";
    HOUSE_TYPES["TWO_FAMILY_HOUSE"] = "TWO_FAMILY_HOUSE";
    HOUSE_TYPES["APARTMENT_HOUSE"] = "APARTMENT_HOUSE";
    HOUSE_TYPES["TOWN_HOUSE"] = "TOWN_HOUSE";
    HOUSE_TYPES["SEMI_DETACHED_HOUSE"] = "SEMI_DETACHED_HOUSE";
})(HOUSE_TYPES || (HOUSE_TYPES = {}));
export var PARCEL_TYPES;
(function (PARCEL_TYPES) {
    PARCEL_TYPES["RESIDENTAL"] = "RESIDENTAL";
    PARCEL_TYPES["INDUSTRIAL"] = "INDUSTRIAL";
    PARCEL_TYPES["MIXED_RESIDENTAL_INDUSTRIAL"] = "MIXED_RESIDENTAL_INDUSTRIAL";
    PARCEL_TYPES["FARMING"] = "FARMING";
    PARCEL_TYPES["OTHER"] = "OTHER";
})(PARCEL_TYPES || (PARCEL_TYPES = {}));
export var PURPOSES_OF_USE;
(function (PURPOSES_OF_USE) {
    PURPOSES_OF_USE["PURCHASE_EXISTING_HOME"] = "PURCHASE_EXISTING_HOME";
    PURPOSES_OF_USE["PURCHASE_NEW_HOME"] = "PURCHASE_NEW_HOME";
    PURPOSES_OF_USE["CONSTRUCTION"] = "CONSTRUCTION";
    PURPOSES_OF_USE["PROLONGATION"] = "PROLONGATION";
    PURPOSES_OF_USE["MODERNIZATION"] = "MODERNIZATION";
    PURPOSES_OF_USE["PROCUREMENT"] = "PROCUREMENT";
})(PURPOSES_OF_USE || (PURPOSES_OF_USE = {}));
export var TYPES_OF_USAGE;
(function (TYPES_OF_USAGE) {
    TYPES_OF_USAGE["SELF_USED"] = "SELF_USED";
    TYPES_OF_USAGE["PARTLY_RENTED"] = "PARTLY_RENTED";
    TYPES_OF_USAGE["RENTED"] = "RENTED";
})(TYPES_OF_USAGE || (TYPES_OF_USAGE = {}));
export var OBJECT_GROUP_TYPE;
(function (OBJECT_GROUP_TYPE) {
    OBJECT_GROUP_TYPE["HOUSE"] = "HOUSE";
    OBJECT_GROUP_TYPE["APARTMENTS"] = "APARTMENTS";
    OBJECT_GROUP_TYPE["PROPERTY"] = "PROPERTY";
})(OBJECT_GROUP_TYPE || (OBJECT_GROUP_TYPE = {}));
export var TIME_OF_DEMAND;
(function (TIME_OF_DEMAND) {
    TIME_OF_DEMAND["AT_ONCE"] = "AT_ONCE";
    TIME_OF_DEMAND["ONE_TO_THREE_MONTHS"] = "ONE_TO_THREE_MONTHS";
    TIME_OF_DEMAND["FOUR_TO_SIX_MONTHS"] = "FOUR_TO_SIX_MONTHS";
    TIME_OF_DEMAND["MORE_THAN_SIX_MONTHS"] = "MORE_THAN_SIX_MONTHS";
    TIME_OF_DEMAND["UNKNOWN"] = "UNKNOWN";
})(TIME_OF_DEMAND || (TIME_OF_DEMAND = {}));
export var PROJECT_STATUSES;
(function (PROJECT_STATUSES) {
    PROJECT_STATUSES["LOOKING_FOR_OBJECT"] = "LOOKING_FOR_OBJECT";
    PROJECT_STATUSES["OBJECT_FOUND"] = "OBJECT_FOUND";
    PROJECT_STATUSES["OBJECT_INSPECTED"] = "OBJECT_INSPECTED";
    PROJECT_STATUSES["NEGOTIATION"] = "NEGOTIATION";
    PROJECT_STATUSES["NOTARY"] = "NOTARY";
    PROJECT_STATUSES["LOOKING_FOR_PARCEL"] = "LOOKING_FOR_PARCEL";
    PROJECT_STATUSES["PARCEL_FOUND"] = "PARCEL_FOUND";
    PROJECT_STATUSES["PARCEL_OWNED"] = "PARCEL_OWNED";
    PROJECT_STATUSES["DEVELOPER_CONTRACTED"] = "DEVELOPER_CONTRACTED";
})(PROJECT_STATUSES || (PROJECT_STATUSES = {}));
